import React, {Fragment} from 'react';
import TextInput from '../../form/TextInput';
import Select from '../../form/Select';
import AddressControl from '../../form/AddressControl';
import createForm from "./Form";
import DateTimeInput from "../../form/DateTimeInput";
import {Tooltip} from "react-tippy";
import CheckBox from "../../form/CheckBox";
import {CurrencyFormatter, ProductColumn, productTooltip, UnitFormatter} from "../../../utils/formatters";
import Icon from "../../form/Icon";
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";

const sortable = true;
const filterable = true;

class ConsignmentReportForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-4 col-sm-push-8">
                        <TextInput name={this.props.componentConfig.idfield} value={this.props.values[this.props.componentConfig.idfield]} label="Kód"
                                   role="idfield" {...this.props.getFieldProps(this.props.componentConfig.idfield)}/>
                    </div>
                    <div className="col-sm-8 col-sm-pull-4">
                        <Select
                            objectValue={true}
                            name="consignor"
                            component="partner"
                            labelKey="name"
                            valueKey="partner_id"
                            storeType="remote"
                            value={this.props.values.consignor}
                            saveChanges={this.props.setFieldValue}
                            label="Partner"
                            {...this.props.getFieldProps("consignor")}/>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-6">
                        <DateTimeInput
                            {...this.props.getFieldProps("startdate")}
                            name="startdate"
                            value={this.props.values.startdate}
                            label="Mettől"
                            showTime={false}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-md-6">
                        <DateTimeInput
                            {...this.props.getFieldProps("enddate")}
                            name="enddate"
                            value={this.props.values.enddate}
                            label="Meddig"
                            showTime={false}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <label className="control-label">Tételek</label>
                        <SelectorGrid
                            {...this.props.getFieldProps("items")}
                            ref={(e) => this.items = e}
                            className={"p-small-table"}
                            exports={[{as: "excel", label: "Excel", icon: "far fa-file-excel"}]}
                            view={["id", "name", "qty", "product_id"]}
                            columns={{
                                "displayname": {
                                    ...ProductColumn("product_id"),
                                    width: 2,
                                },
                                "barcode": {
                                    header: 'Vonalkód',
                                    width: 1,
                                    sortable,
                                    filterable
                                },
                                "listprice": {
                                    header: 'Ár',
                                    width: 2,
                                    sortable,
                                    filterable,
                                    renderer: CurrencyFormatter,
                                    className: "currency"
                                },
                                "qty": {
                                    header: 'Darabszám',
                                    width: 2,
                                    sortable,
                                    filterable,
                                    renderer: (value, row) => UnitFormatter(value || 0, row.unit),
                                    className: "unit"
                                }
                            }}
                            aggregations={{
                                fields: {
                                    "qty": {
                                        field: "qty", type: "SUM"
                                    }
                                }
                            }}
                            listfield="reportitems"
                            data={this.props.values}
                            orderBy={{field: "displayname", direction: "ASC"}}
                            componentConfig={this.props.componentConfig}
                        />
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(ConsignmentReportForm);
